import colors from "common/styles/colors";

export const badgeEntitlementsDialogStyles = {
  dialogTitle: {
    fontSize: 22,
    fontWeight: 600,
    pb: 1
  },
  dialogTitleContainer: {
    paddingBottom: "1px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  dialogCloseButton: {
    cursor: "pointer",
    fontSize: 25,
    position: "absolute",
    top: 16,
    right: 16
  },
  dialogContent: {
    pt: 0.5
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 120
  },
  noEntitlementsMessage: {
    mt: 2,
    fontWeight: 400
  },
  subtitle: {
    mb: 2
  },
  dialogActions: {
    pr: 3,
    pb: 4
  },
  closeButton: {
    minWidth: 90,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 14
  },
  badgeProductCell: {
    textDecoration: "none",
    color: colors.primary,
    fontSize: 14,
    fontWeight: 600,
    cursor: "default"
  }
};
